import { FC, ReactElement } from 'react';

import { useGetScreenStatus } from '../../../hooks';
import { SCREEN_STATUS } from '../../../types';
import {
  StyledHero,
  StyledHeroContent,
  StyledHeroLeft,
  StyledHeroLogo,
  StyledHeroSubTitle,
  StyledHeroTitle,
} from './Hero.styles';

export type HeroSize = 'small' | 'large';
export interface HeroProps {
  title: string;
  subtitle?: string;
  image: string;
  backgroundColor: string;
  isSmallScreen?: boolean;
  size?: HeroSize;
  actions?: ReactElement[] | ReactElement;
}

export const Hero: FC<HeroProps> = ({ title, subtitle, image, size = 'large', actions }) => {
  const currentScreen = useGetScreenStatus();
  const isSmallScreen = currentScreen === SCREEN_STATUS.small || currentScreen === SCREEN_STATUS.extraSmall;

  return (
    <StyledHero image={image} isSmallScreen={isSmallScreen} size={size}>
      <StyledHeroContent>
        <StyledHeroLeft>
          <StyledHeroLogo image={image} isSmallScreen={isSmallScreen} size={size} />
          <div>
            <StyledHeroTitle isSmallScreen={isSmallScreen} size={size} data-cy="hero-title">
              {title}
            </StyledHeroTitle>
            <StyledHeroSubTitle isSmallScreen={isSmallScreen} size={size}>
              {subtitle}
            </StyledHeroSubTitle>
          </div>
        </StyledHeroLeft>
        {actions}
      </StyledHeroContent>
    </StyledHero>
  );
};
